var __fast_options = __fast_options || {};
__fast_options.with_product_attributes = true;
__fast_options.bring_product_pdp_images = true;
__fast_options.disable_upsell_shadow_root = true;
/*yan edit*/
__fast_options.show_carousel_marks_not_just_on_hover = true;
__fast_options.product_image_custom_class = 'fs-first-image';
/*yan edit end*/

// PDP image #2 (index 1) is the lifestyle shot addHoverImage() layers over the
// tile as the hover swap, so leaving it in FS's own tile carousel showed the
// same photo twice: once on hover, once as a carousel slide. Fast Simon support
// pointed at this option (docs.fastsimon.com/customization/docs/upsell-crossell/
// options) — it drops the given PDP-image indexes from the tile carousel only,
// leaving `attributes["Product images"]` (what getSecondProductImage reads)
// untouched, so the hover overlay is unaffected.
//
// Keep in step with getSecondProductImage(): if the hover image ever moves off
// index 1, this index has to move with it.
__fast_options.omit_carousel_image_indexes = [1];

const upWishlistHeart = {
    ICON_SVG: `<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2896 1.11037C12.9378 0.758353 12.52 0.479105 12.0602 0.288584C11.6004 0.0980619 11.1076 0 10.6098 0C10.1121 0 9.61928 0.0980619 9.15947 0.288584C8.69966 0.479105 8.2819 0.758353 7.93004 1.11037L7.19982 1.8406L6.46959 1.11037C5.75887 0.39965 4.79492 0.000368394 3.7898 0.000368401C2.78468 0.000368409 1.82073 0.39965 1.11001 1.11037C0.399281 1.8211 7.4887e-09 2.78505 0 3.79017C-7.4887e-09 4.79528 0.399281 5.75923 1.11001 6.46996L1.84023 7.20018L7.19982 12.5598L12.5594 7.20018L13.2896 6.46996C13.6416 6.1181 13.9209 5.70034 14.1114 5.24053C14.3019 4.78072 14.4 4.28788 14.4 3.79017C14.4 3.29245 14.3019 2.79961 14.1114 2.3398C13.9209 1.88 13.6416 1.46223 13.2896 1.11037V1.11037Z" fill="white"/></svg>`,

    _clickBound: false,

    bindClickOnce: () => {
        if (upWishlistHeart._clickBound) return;
        upWishlistHeart._clickBound = true;
        document.addEventListener(
            "click",
            (e) => {
                const cta = e.target.closest(".product-wishlist-cta.js-wishlist-cta");
                if (!cta) return;
                e.preventDefault();
                e.stopPropagation();
                upWishlistHeart.toggle(cta);
            },
            true
        );
    },

    toggle: (cta) => {
        if (typeof addProductToWishList === "undefined") return; // wishlist JS not loaded
        if (cta.dataset.wlBusy === "1") return;                  // in-flight guard
        const icon = cta.querySelector(".wishlist-default-icon");
        const loader = cta.querySelector(".wishlist-loader");
        const productID = cta.dataset.productId;
        const email = window.maCustomerEmail || "";
        const isActive = icon && icon.classList.contains("is-active");

        cta.dataset.wlBusy = "1";
        if (loader) loader.classList.remove("dawn-hidden");
        const done = () => {
            if (loader) loader.classList.add("dawn-hidden");
            cta.dataset.wlBusy = "0";
            if (typeof window.maSyncWishlistIcons === "function") window.maSyncWishlistIcons();
        };

        if (!isActive) {
            addProductToWishList(email, {product_id: productID})
                .then(() => {
                    if (icon) icon.classList.add("is-active");
                    if (typeof sendToGTM === "function") {
                        sendToGTM(productID, window.maWishlistTemplate === "search" ? "search" : "collection");
                    }
                    done();
                })
                .catch(done);
        } else if (typeof deleteWishlistItemByProductId !== "undefined") {
            deleteWishlistItemByProductId(email, productID)
                .then(() => {
                    if (icon) icon.classList.remove("is-active");
                    done();
                })
                .catch(done);
        } else {
            done();
        }
    },

    set: (product, productElement) => {
        upWishlistHeart.bindClickOnce();

        for (const el of productElement.querySelectorAll(".fs-heart-button-wrapper")) {
            el.remove();
        }

        // Idempotent — FS re-renders tiles on sort/filter/paginate.
        if (productElement.querySelector(".js-wishlist-cta")) return;

        const productID = productElement.dataset.productId || productElement.dataset.id;
        if (!productID) return;

        const imageWrapper = productElement.querySelector(".image-wrapper");
        if (!imageWrapper) return;

        imageWrapper.insertAdjacentHTML(
            "beforeend",
            `<div class="product-wishlist-cta js-wishlist-cta" data-product-id="${productID}">
        <div class="product-wishlist-icon">
          <div class="wishlist-default-icon">
            <div class="dawn-hidden wishlist-loader"><span class="wishlist-loader-icon"></span></div>
            ${upWishlistHeart.ICON_SVG}
          </div>
        </div>
      </div>`
        );
    },
};

function getFirstProductImage(data) {
    if (!data?.attributes) return null;

    const productImagesAttr = data.attributes.find(
        (attr) => attr[0] === "Product images"
    );

    const images = productImagesAttr?.[1];

    if (!Array.isArray(images) || images.length < 2) return null;

    return images[0];
}

function getSecondProductImage(data) {
    if (!data?.attributes) return null;

    const productImagesAttr = data.attributes.find(
        (attr) => attr[0] === "Product images"
    );

    const images = productImagesAttr?.[1];

    if (!Array.isArray(images) || images.length < 2) return null;

    return images[1];
}

function addHoverImage(productElement, data, reverse = false) {
    const secondImage = getSecondProductImage(data);
    if (!secondImage) return;

    const wrapper = productElement.querySelector(".image-wrapper");
    const firstImage = wrapper?.querySelector("img");

    if (!wrapper || !firstImage) return;

    // Prevent duplicate images
    if (wrapper.querySelector(".fs-second-image")) return;

    wrapper.style.position = "relative";
    wrapper.style.overflow = "hidden";

    firstImage.classList.add("fs-first-image");

    const secondImg = document.createElement("img");
    secondImg.src = secondImage;
    secondImg.alt = firstImage.alt;
    secondImg.className = "fs-second-image";
    secondImg.loading = "lazy";
    secondImg.decoding = "async";

    if (reverse) {
        wrapper.classList.add("fs-hover-reverse");
    }

    // Make the hover image clickable
    const link = document.createElement("a");
    link.href = data.productURL;
    link.setAttribute("aria-label", firstImage.alt);
    // Classed so the carousel-engaged CSS can hide the whole overlay: hiding
    // only the <img> would leave this transparent, inset:0 anchor sitting over
    // the vendor's carousel image.
    link.className = "fs-second-image-link";
    link.style.position = "absolute";
    link.style.inset = "0";
    link.style.display = "block";

    link.appendChild(secondImg);
    wrapper.appendChild(link);

    upsellSyncHoverOverlayToCarousel(wrapper);
}

// Port of syncHoverOverlayToCarousel() in assets/fast-simon.js (the SERP grid) —
// the recommendation tiles run the same static-overlay-over-a-live-carousel
// trick, so they have the same staleness problem. The overlay above is only
// truthful while the tile is resting on its home image: it is a STATIC copy of
// PDP image #2 layered over FS's own carousel <img>. Once the shopper flicks
// that carousel (arrow, marker or swipe), the vendor img underneath is on an
// image they chose, so leaving the overlay up (reverse mode shows it by
// default) or fading it back in on mouse-out would show a stale shot. So the
// overlay is gated on the carousel position: hidden (and the vendor img pinned
// visible) off the home image, restored — hover swap and all — the moment the
// carousel comes back to it. FSUpsellStyle carries both states off
// .fs-carousel-engaged; .fs-hover-reverse deliberately stays on the wrapper
// throughout, so dropping .fs-carousel-engaged brings the hover behaviour back
// with no second bit of state to keep in sync.
//
// The overlay LEAVES rather than blinks out: FSUpsellStyle slides it a full tile
// width and fades it while the vendor's next slide arrives underneath, so the
// swap reads as part of the carousel instead of a hard cut. The travel is
// entirely CSS — this function only owns the class, exactly as it did before the
// animation existed.
//
// Driven by a MutationObserver rather than click handlers on the controls: the
// vendor lazy-mounts its arrows/markers on first pointer interaction (nothing to
// bind to at hook time), re-renders its <img> on navigation (a captured node
// goes stale), and swipe navigation fires no control click at all. Watching the
// image subtree catches every route into a position change.
//
// "Home" is identified by the IMAGE the carousel is resting on, not by a marker
// index: the vendor's default-selected marker is not necessarily the first one,
// so any index-based test could read the resting state as "already navigated"
// and suppress the overlay permanently. Comparing images sidesteps the ordering.
function upsellSyncHoverOverlayToCarousel(wrapper) {
    let homeKey = "";
    let queued = false;

    const sync = () => {
        queued = false;

        // The vendor image, never our overlay: FS tags its own product image
        // with `image` and (via __fast_options.product_image_custom_class) with
        // `fs-first-image`; a re-render can drop the custom class, hence both.
        const vendorImg = wrapper.querySelector(
            "img.fs-first-image:not(.fs-second-image), img.image:not(.fs-second-image)"
        );
        const currentKey = upsellNormalizeImageKey(vendorImg?.getAttribute("src"));

        // The first real src we see is the resting position — the image the
        // overlay was built to sit on top of. Captured lazily rather than at
        // hook time because the vendor may still be on a lazy-load placeholder
        // then; until it resolves, currentKey is blank and we stay un-engaged
        // (overlay shown), which is the correct initial state anyway.
        if (!homeKey) homeKey = currentKey;

        const engaged = Boolean(currentKey) && currentKey !== homeKey;

        // Unlike the SERP twin — which observes .image-wrapper but toggles the
        // class on its PARENT .fs-product-main-image-wrapper — the recommendation
        // tile has no such outer element, so the observed node and the toggled
        // node are the same .image-wrapper. Write the class only when it actually
        // changes: an unconditional toggle re-fires this observer every time and
        // spins a permanent requestAnimationFrame loop per tile.
        if (wrapper.classList.contains("fs-carousel-engaged") === engaged) return;
        wrapper.classList.toggle("fs-carousel-engaged", engaged);
    };

    const observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        // Coalesce: the vendor mutates src + marker classes in the same tick.
        requestAnimationFrame(sync);
    });

    observer.observe(wrapper, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["src", "class"],
    });

    sync();
}

// Shopify serves one asset under many URLs (…_1200x.jpg?v=17 vs …_600x.jpg),
// and the vendor re-renders its <img> on navigation — so identity is the CDN
// path minus the query string and Shopify's _WxH size token, not the raw src.
// Twin of normalizeImageKey() in assets/fast-simon.js; prefixed because both
// files load together on collection/search templates and these are top-level
// declarations.
function upsellNormalizeImageKey(src) {
    if (!src) return "";

    let path = src;
    try {
        path = new URL(src, window.location.href).pathname;
    } catch (e) {
        // Odd/relative src the URL parser rejects — compare the raw string.
    }

    return path.replace(/_(\d+x\d*|x\d+)(_crop_\w+)?(?=\.[a-z0-9]+$)/i, "");
}

function addHoverSwapSecondImage(productElement, data) {
    // Touch-primary devices (phones/tablets: no hover to swap on) use FS's own
    // swipe carousel for the tile images instead — skip the overlay entirely so
    // the vendor img stays touchable AND the extra lifestyle image is never
    // fetched (a display:none <img> still downloads). Touchscreen laptops keep
    // the overlay: their PRIMARY pointer is a fine hover-capable one, so this
    // query stays false there. FSStyle gates the same rules with the same media
    // query as a belt-and-braces fallback.
    if (window.matchMedia("(hover: none), (pointer: coarse)").matches) return;

    const firstImage = getFirstProductImage(data);
    if (!firstImage) return;
    const secondImage = getSecondProductImage(data);
    if (!secondImage) return;


    const imageWrapper = productElement.querySelector(
        ".fs-upsell-cross-sell-product .image-wrapper"
    );

    if (!imageWrapper) return;

    const originalImage = [...imageWrapper.querySelectorAll("img.image")]
        .find((img) => img.dataset.fsSecondImage !== "true");

    if (!originalImage) return;

    // Avoid adding the second image multiple times
    let secondImageEl = imageWrapper.querySelector('img[data-fs-second-image="true"]');

    if (!secondImageEl) {
        secondImageEl = originalImage.cloneNode(true);

        secondImageEl.classList.add("2-image");
        secondImageEl.dataset.fsSecondImage = "true";

        originalImage.insertAdjacentElement("afterend", secondImageEl);
    }

    // Set second image URL
    secondImageEl.src = secondImage;

    // Remove srcset if it exists, so browser uses the new src
    secondImageEl.removeAttribute("srcset");

    // FSStyle scopes the overlay + hover-fade rules to this class, so cards
    // without a second image never get a mispositioned overlay.
    productElement.classList.add("fs-has-second-image");
}

// MSA-435: metaobject-driven discount badges on the recommendation carousel.
// Twin of assets/fast-simon.js `MetaobjectBadges` (the SERP grid) — duplicated
// here for the same reason upWishlistHeart above is: fast-simon.js is SERP-only
// (loaded inside the `use_fastsimon and fs_on_serp` gate in theme.liquid), so
// on the homepage — where the tabbed carousel lives — neither MetaobjectBadges
// nor the #fs-badge-data blob nor FSStyle's badge CSS is present. This file is
// the only FS script that loads site-wide, so the recommendation surface needs
// its own copy. Named UpsellMetaobjectBadges (not MetaobjectBadges) so it can't
// clash with fast-simon.js's top-level `const` on pages where BOTH load.
// Badge priority mirrors native/SERP: SOLD OUT → inventory_promo (best valid,
// variant-matched) → product_badge (tag-matched, date-gated) → FINAL SALE.
// Data blob (#fs-badge-data) is rendered by the section via {% render
// 'FSBadgeData' %}, gated by settings.enable_discount_label. Badge CSS is
// scoped to the carousel in the section's {% style %} block.
const UpsellMetaobjectBadges = {
    // undefined = not read yet; null = blob absent/unparseable (skip injection)
    config: undefined,

    load: () => {
        if (UpsellMetaobjectBadges.config !== undefined) return UpsellMetaobjectBadges.config;
        const el = document.getElementById("fs-badge-data");
        if (!el) {
            UpsellMetaobjectBadges.config = null;
            return null;
        }
        try {
            const parsed = JSON.parse(el.textContent);
            UpsellMetaobjectBadges.config = {
                productBadges: Array.isArray(parsed.productBadges) ? parsed.productBadges : [],
                inventoryPromotions: Array.isArray(parsed.inventoryPromotions) ? parsed.inventoryPromotions : [],
            };
        } catch (e) {
            UpsellMetaobjectBadges.config = null;
        }
        return UpsellMetaobjectBadges.config;
    },

    normalizeTag: (tag) => tag?.toLowerCase().replace(/\s+/g, ""),

    normalizeVariantId: (id) => String(id).replace("gid://shopify/ProductVariant/", ""),

    isDateActive: (startDate, endDate, nowSeconds) => {
        const start = startDate ? Math.floor(Date.parse(startDate) / 1000) : null;
        const end = endDate ? Math.floor(Date.parse(endDate) / 1000) : null;
        if (start !== null && Number.isNaN(start)) return false;
        if (end !== null && Number.isNaN(end)) return false;
        if (start !== null && nowSeconds < start) return false;
        if (end !== null && nowSeconds > end) return false;
        return true;
    },

    createBadge: ({label, bgColor, textColor}) => {
        const masterSpacing = typeof label === "string" && label.includes("<font>")
            ? " fs-ma-badge__label--master-spacing"
            : "";
        return `
      <div class="text-badge fs-ma-badge" style="--bg-color: ${bgColor}; --color: ${textColor};">
        <span class="fs-ma-badge__label${masterSpacing}">${label}</span>
      </div>
    `;
    },

    // The recommendation payload differs from the SERP payload: tags live in
    // `data.attributes` under the "Tag" name (not `data.tags`), and variants are
    // `data.variants[].id` (not `data.vra[].v_id`). Normalise to the shape the
    // matching logic expects, then run the identical priority chain.
    fromRecommendationData: (data) => {
        const tagAttr = (data.attributes || []).find((a) => a[0] === "Tag");
        return {
            tags: Array.isArray(tagAttr && tagAttr[1]) ? tagAttr[1] : [],
            isSoldOut: data.isSoldOut,
            variantIds: (data.variants || []).map((v) => String(v.id)),
        };
    },

    set: (data, productElement) => {
        const config = UpsellMetaobjectBadges.load();
        if (!config) return;

        if (productElement.querySelectorAll(".fs-badges-wrapper").length === 0) {
            productElement
                .querySelector(".image-wrapper")
                ?.insertAdjacentHTML("afterbegin", `<div class="fs-badges-wrapper"></div>`);
        }
        const wrapper = productElement.querySelector(".fs-badges-wrapper");
        if (!wrapper) return;

        productElement.classList.add("fs-ma-badged");

        // Clear a previous run — FS re-renders tiles on tab switch / re-init.
        for (const stale of productElement.querySelectorAll(".fs-ma-badge")) {
            stale.remove();
        }

        const {tags: rawTags, isSoldOut, variantIds} = UpsellMetaobjectBadges.fromRecommendationData(data);
        const nowSeconds = Math.floor(Date.now() / 1000);
        const tags = rawTags.map(UpsellMetaobjectBadges.normalizeTag);
        const badges = [];

        if (isSoldOut) {
            badges.push({label: "SOLD OUT", bgColor: "#D3C1B2", textColor: "#222"});
        } else {
            const variantIdSet = new Set(variantIds);
            const validPromos = config.inventoryPromotions.filter(
                (promo) =>
                    UpsellMetaobjectBadges.isDateActive(promo.start_date, promo.end_date, nowSeconds) &&
                    promo.variants?.some((gid) =>
                        variantIdSet.has(UpsellMetaobjectBadges.normalizeVariantId(gid))
                    )
            );

            if (validPromos.length > 0) {
                validPromos.sort((a, b) => {
                    if (b.percentage !== a.percentage) return b.percentage - a.percentage;
                    if (a.type === "RETURN" && b.type !== "RETURN") return -1;
                    if (b.type === "RETURN" && a.type !== "RETURN") return 1;
                    return 0;
                });
                const best = validPromos[0];
                badges.push({
                    label: best.plp_badge_name,
                    bgColor: best.background_color,
                    textColor: best.text_color,
                });
            } else {
                for (const badge of config.productBadges) {
                    const badgeTag = UpsellMetaobjectBadges.normalizeTag(badge.product_tag);
                    if (badgeTag === "product:discontinued") continue;
                    if (!UpsellMetaobjectBadges.isDateActive(badge.start_date, badge.end_date, nowSeconds)) continue;
                    if (!tags.includes(badgeTag)) continue;
                    badges.push({
                        label: badge.badge_name,
                        bgColor: badge.background_color,
                        textColor: badge.text_color,
                    });
                }
            }
        }

        if (tags.includes("product:discontinued")) {
            badges.push({label: "FINAL SALE", bgColor: "#501008", textColor: "#ffffff"});
        }

        for (const badge of badges) {
            wrapper.insertAdjacentHTML("beforeend", UpsellMetaobjectBadges.createBadge(badge));
        }
    },
};

// Twin of assets/fast-simon.js `getFsProductTags` / `getZeroReviewLabel`, for
// the recommendation carousel. Duplicated for the same reason
// UpsellMetaobjectBadges is: fast-simon.js is SERP-only, so nothing it defines
// exists on the surfaces this file runs on.
//
// Every tag we can see for a product, normalized the same way
// UpsellMetaobjectBadges.normalizeTag does (lowercased, whitespace stripped).
// On this surface tags arrive in the `attributes` "Tag" pair (see
// fromRecommendationData above); `data.tags` is unioned in as a defensive
// fallback in case a payload carries the SERP shape instead.
function getUpsellProductTags(data) {
    const attributeTags = UpsellMetaobjectBadges.fromRecommendationData(data || {}).tags;
    const payloadTags = Array.isArray(data?.tags) ? data.tags : [];

    return [...payloadTags, ...attributeTags]
        .filter((tag) => typeof tag === "string")
        .map(UpsellMetaobjectBadges.normalizeTag);
}

// Label for the rating slot of a ZERO-review tile (native shows "New" there via
// snippets/okendo-reviews-product-rating-summary.liquid). Only ever called for
// products with no reviews — the caller owns that gate. Precedence, highest
// first:
//   1. "Last Chance"  — carries the "product: Discontinued" tag
//   2. "Stylist Pick" — no "product: Discontinued" tag AND no "new" tag
//   3. "New"          — everything else (i.e. it does carry the "new" tag)
function getUpsellZeroReviewLabel(data) {
    const tags = getUpsellProductTags(data);

    if (tags.includes("product:discontinued")) {
        return "Last Chance";
    }

    // The store tags newness as "New: Yes"; accept a bare "new" tag too.
    const hasNewTag = tags.includes("new:yes") || tags.includes("new");

    return hasNewTag ? "New" : "Stylist Pick";
}

function upsellHooks() {
    FastRecommendationWidget.registerHook("upsell-cross-sell-products", ({element, products}) => {
        const productElements = [...element.querySelectorAll(".fs-upsell-cross-sell-product")];

        for (const productElement of productElements) {
            const productID = productElement.dataset.id;
            const data = products[productID];

            if (typeof data !== "undefined" && data !== null) {
                productElement.classList.add("fs-product-processed");

                if (window.location.pathname.includes('/products/')) {
                    addHoverImage(productElement, data, true);
                } else {
                    addHoverImage(productElement, data);
                }

                const reviewsCount = productElement.querySelector(".fs-recommendation-review-count");
                if (reviewsCount && !reviewsCount.dataset.fsReformatted) {
                    const countMatch = reviewsCount.textContent.match(/\d+/);
                    if (countMatch) {
                        reviewsCount.textContent =
                            countMatch[0] === "1" ? "1 Review" : `${countMatch[0]} Reviews`;
                        reviewsCount.dataset.fsReformatted = "true";
                    }
                }

                // Fast Simon uses `.fs-reviews-count` only for the zero-review
                // shape. Keep the RC-reviewed selector above byte-for-byte and
                // format this fallback separately so both DOM shapes are safe.
                const zeroReviewsCount = productElement.querySelector(".fs-reviews-count");
                if (zeroReviewsCount && !zeroReviewsCount.dataset.fsReformatted) {
                    const zeroCountMatch = zeroReviewsCount.textContent.match(/\d+/);
                    if (zeroCountMatch) {
                        zeroReviewsCount.textContent =
                            zeroCountMatch[0] === "1" ? "1 Review" : `${zeroCountMatch[0]} Reviews`;
                        zeroReviewsCount.dataset.fsReformatted = "true";
                    }
                }

                const ratingSummaryHost = productElement.querySelector(".reviews-container");
                if (ratingSummaryHost && !ratingSummaryHost.querySelector(".fs-reviews-summary")) {
                    const summaryParts = ratingSummaryHost.querySelectorAll(
                        ".fs-recommendation-review-avg, .fs-reviews-avg, .reviews-count, .fs-recommendation-review-count, .fs-reviews-count"
                    );

                    const topLevelParts = [...summaryParts].filter(
                        (part, i, all) => !all.some((other, j) => j < i && other.contains(part))
                    );

                    if (topLevelParts.length) {
                        const summary = document.createElement("div");
                        summary.classList.add("fs-reviews-summary");
                        topLevelParts[0].parentNode.insertBefore(summary, topLevelParts[0]);

                        for (const part of topLevelParts) {
                            summary.appendChild(part);
                        }
                    }
                }

                const ratingRow = productElement.querySelector(".reviews-container");

                if (ratingRow && !ratingRow.querySelector(".product-zero-reviews-label")) {
                    const payloadCount =
                        data && typeof data.reviewCount === "number" ? data.reviewCount : null;

                    const reviewsCountEl = ratingRow.querySelector(".reviews-count");
                    const domReviewCount = reviewsCountEl
                        ? parseInt(reviewsCountEl.textContent, 10)
                        : null;

                    const hasNoReviews =
                        payloadCount !== null
                            ? payloadCount === 0
                            : domReviewCount === 0;

                    if (hasNoReviews) {
                        // Hide stars and review count
                        ratingRow.querySelectorAll(".star, .reviews-count").forEach((el) => {
                            el.style.display = "none";
                        });

                        const newLabel = document.createElement("div");
                        newLabel.className = "product-zero-reviews-label";
                        newLabel.textContent = getUpsellZeroReviewLabel(data);
                        ratingRow.appendChild(newLabel);
                    }
                }

                upWishlistHeart.set(data, productElement);

                // MSA-435: metaobject-driven discount badges (SOLD OUT /
                // inventory promo / product_badge / FINAL SALE) — mirrors the
                // SERP grid's MetaobjectBadges.set() call. See module above.
                UpsellMetaobjectBadges.set(data, productElement);

                // Check for the compare-container and move its value under the price-container only if not already added
                const compareElement = productElement.querySelector(".fs-recommendation-compare-container .compare");
                const priceContainer = productElement.querySelector(".fs-recommendation-price-container .price");

                // Check if the compare value is not already appended
                if (compareElement && priceContainer && !productElement.querySelector(".compare-price")) {
                    const compareValue = compareElement.textContent.trim();

                    // Create a new div element to append the compare value under the price
                    const comparePriceDiv = document.createElement("div");
                    comparePriceDiv.classList.add("compare-price");
                    comparePriceDiv.textContent = compareValue;
                    priceContainer.appendChild(comparePriceDiv); // Append the compare value under the price

                    new MutationObserver(() => {
                        if (priceContainer.lastChild !== comparePriceDiv) {
                            priceContainer.appendChild(comparePriceDiv);
                        }
                    }).observe(priceContainer, {childList: true});
                }

                const attributes = data.attributes || [];

                // Find "Global.type plp filter"
                const typeAttribute = attributes.find(
                    (attr) => attr[0] === "Global.badges"
                );

                const shortTitleAttribute = attributes.find(
                    (attr) => attr[0] === "Global.short title"
                );

                if (shortTitleAttribute && Array.isArray(shortTitleAttribute[1]) && shortTitleAttribute[1][0]) {
                    const titleElement = productElement.querySelector(".fs-recommendation-title-wrapper .name");

                    if (titleElement) {
                        titleElement.textContent = shortTitleAttribute[1][0];
                    }
                }

                if (typeAttribute && Array.isArray(typeAttribute[1])) {
                    // Keep every merchant badge; reverse a copy without mutating the payload.
                    const labels = typeAttribute[1].slice().reverse();

                    // Avoid adding labels more than once
                    if (!productElement.querySelector(".fs-card-product__labels")) {
                        const labelsWrapper = document.createElement("div");
                        labelsWrapper.classList.add("fs-card-product__labels");

                        labels.forEach((label) => {
                            const labelElement = document.createElement("div");
                            labelElement.classList.add("fs-card-product__label");

                            const span = document.createElement("span");
                            span.textContent = label;

                            labelElement.appendChild(span);
                            labelsWrapper.appendChild(labelElement);
                        });

                        const infoContainer = productElement.querySelector(".info-container");

                        if (infoContainer) {
                            infoContainer.appendChild(labelsWrapper);
                        }
                    }
                }
            }
        }

        if (typeof window.maSyncWishlistIcons === "function") {
            window.maSyncWishlistIcons();
        }
    });
}

if (window.FastRecommendationWidget) {
    upsellHooks();
} else {
    window.addEventListener('fast-upsell-cross-sell-ready', function () {
        upsellHooks();
    });
}
